import React, { useEffect, useState } from "react";

// Components
import Modal from "../Modal";
import Input from "../Input";
import Select from "../Select";

const ModalCreateIaSurvey = (props) => {
  const [data, setData] = useState({});
  const [disabled, setDisabled] = useState(true);

  let props_temp = { small: true };
  if (props.secondButton == true) {
    props_temp = { medium: true };
  }
  const valid = () => {
    return (
      Object.keys(data).length === 4 &&
      Object.values(data).every(
        (value) => value !== undefined && value !== null && value !== "",
      )
    );
  };

  useEffect(() => {
    setDisabled(!valid());
  }, [data]);

  return (
    <Modal isVisible={true} {...props_temp} medium>
      <h2 className="c-modal-ia__title c-modal-ia-create-survey__title">
        {props.text}
      </h2>
      <p className="c-modal-ia-create-survey__text">
        Crea il tuo test di verifica delle conoscenze utilizzando questa procedura guidata.
        Indica semplicemente le conoscenze da valutare e configurane la difficoltà e
        il numero di domande:
      </p>
      <form className="c-modal-ia-create-survey__form">
        <Input
          isRequired
          name="name"
          label="Nome del test"
          errorLabel="This field can not be blank"
          minCharacters={5}
          type="text"
          value={data.name}
          onChange={(e) => setData({ ...data, ["name"]: e.target.value })}
          maxLength={20}
          hintLabel="È un nome interno, per identificare il test quando lo si utilizza (max. 20 caratteri)."
          showHint={true}
        />
        <Input
          isRequired
          name="name"
          label="Conoscenza del test:"
          errorLabel="This field can not be blank"
          minCharacters={5}
          type="text"
          value={data.assessment_type}
          onChange={(e) =>
            setData({ ...data, ["assessment_type"]: e.target.value })
          }
          maxLength={30}
          hintLabel="Scrivi qui le competenze che vuoi valutare. Puoi scrivere una sola parola, ad esempio Java, HTML, Francese, Excel... oppure specificare cosa vuoi valutare (max 30 caratteri)."
          showHint={true}
        />

        <Select
          label="Numero di domande"
          withoutInput
          isRequired
          valueSelected={data.questions_number}
          options={Array.from({ length: 50 }, (_, i) => ({
            text: i + 1,
            value: i + 1,
          }))}
          optionClick={(text, value) =>
            setData({ ...data, ["questions_number"]: value })
          }
          style={{ zIndex: 1005, marginTop: 24 }}
          tick
        />
        <Select
          label="Nivel de Dificultad"
          withoutInput
          isRequired
          valueSelected={data.level}
          options={[
            { text: "Essenziale", value: "basico" },
            { text: "Medio", value: "medio" },
            { text: "Avanzato", value: "avanzado" },
            { text: "Molto Alto", value: "muy alto" },
          ]}
          optionClick={(text, value) => setData({ ...data, ["level"]: value })}
          style={{ zIndex: 1005 }}
          tick
        />
      </form>
      <div className="c-button__wrapper c-modal-ia-create-survey__buttons">
        <button
          type="button"
          className="c-button c-button--cancel c-modal__button"
          onClick={() => props.closeModal()}
        >
          <span className="c-button__text">Cancel</span>
        </button>
        <button
          type="button"
          className="c-button c-modal__button"
          disabled={disabled}
          onClick={() => props.create(data)}
        >
          <span className="c-button__text">Creare</span>
        </button>
      </div>
    </Modal>
  );
};

export default ModalCreateIaSurvey;
